const POSTER = Object.freeze({ id: 'poster', particleCount: 0, maxDpr: 1, bloom: false, animate: false });
const MOBILE = Object.freeze({ id: 'mobile', particleCount: 20000, maxDpr: 1.25, bloom: false, animate: true });
const FULL = Object.freeze({ id: 'full', particleCount: 50000, maxDpr: 1.75, bloom: true, animate: true });

// Unknown/undefined deviceMemory or hardwareConcurrency (e.g. Safari/iOS never
// exposes navigator.deviceMemory) must fail SAFE toward the constrained tier,
// not fail open toward FULL — an undefined comparison (`undefined < 4`) is
// always false, so a naive `<` check would silently grant the top tier to the
// platform most likely to need the downgrade.
function isConstrained(value) {
  return Number.isFinite(value) ? value < 4 : true;
}

export function selectVisualTier(c) {
  if (!c.enabled || !c.webgl || c.reducedMotion || c.reduceEffects || c.saveData || c.lowPower) return POSTER;
  if (c.mobile || isConstrained(c.deviceMemory) || isConstrained(c.hardwareConcurrency)) return MOBILE;
  return FULL;
}
